/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

//search feature
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/esm/Col";
import Form from "react-bootstrap/esm/Form";
import InputGroup from "react-bootstrap/esm/InputGroup";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll, getByInvestigator } from "../../../utils/requests/dynamicReq";
import { paths } from "../../../utils/paths";

import { useSelector } from "react-redux";
import { IStore } from "../../../interfaces/IStore";
import { IUser } from "../../../interfaces/IUser";
import { investigatorRoles } from "../../../utils/roles";
import { normalizer } from "../../../utils/auxiliar/investigators";
import { Table } from "react-bootstrap";

export const Propuestas: FC = () => {
  let { staffId, isAdmin, userRoleId } = useSelector(
    ({ user }: IStore) => user as IUser
  );
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { PROPUESTAS } = paths;
  const [propuestas, setPropuestas] = useState<IPropuestaShort[]>([]);
  const [displayPropuestas, setDisplayPropuestas] = useState<IPropuestaShort[]>(
    []
  );
   const [sortConfig, setSortConfig] = useState<{
     key: string;
     direction: string;
   } | null>(null);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    loadData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);
  interface IPropuestaShort {
    id: string;
    estado: string;
    referencia: string;
    acronimo: string;
    fechaInicio: string;
    staffIpIds: string;
    gestionadoPor: string;
  }
const loadData = async () => {
  try {
    const response = await getAll(PROPUESTAS, source);

    if (isMountedRef.current) {
      let filteredPropuestas = response;

      // Si el usuario NO es admin, aplicar el filtro
      if (!(isAdmin )) {
        filteredPropuestas = response.filter(
          (propuesta:any) =>
            propuesta.staffIp.some((staff: any) => staff.id === staffId) ||
            propuesta.staffParticipante.some(
              (staff: any) => staff.id === staffId
            )
        );
      }

      setPropuestas(filteredPropuestas);
      setDisplayPropuestas(filteredPropuestas);
    }
    setIsLoading(false);
  } catch (error) {
    console.log("HTTP call cancelled");
  }
};


const searchBar = (value: string) => {
  const normalizedValue = normalizer(value).toLowerCase();

  setDisplayPropuestas(
    propuestas.filter(
      ({ acronimo, referencia }) =>
        normalizer(acronimo).toLowerCase().includes(normalizedValue) ||
        normalizer(referencia).toLowerCase().includes(normalizedValue)
    )
  );

  if (!value) {
    setDisplayPropuestas(propuestas);
  }
};

     const sortByColumn = (key: any) => {
       let direction = "desc";
       if (
         sortConfig &&
         sortConfig.key === key &&
         sortConfig.direction === "desc"
       ) {
         direction = "asc";
       }
       setSortConfig({ key, direction });
       const sortedData = [...displayPropuestas].sort((a: any, b: any) => {
         if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
         if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
         return 0;
       });
       setDisplayPropuestas(sortedData);
     };


const columnHeaders: Record<string, string> = {
  estado: "ESTADO",
  referencia: "REFERENCIA",
  acronimo: "TÍTULO", // Cambio aquí, pero mantiene la clave "acronimo"
  fechaInicio: "FECHA",
  staffIp: "IPS",
  gestionadoPor: "GESTIONADO POR",
};

  return (
    <div className="container-fluid p-4">
      {(isAdmin || userRoleId === 2 || userRoleId === 3) && (
        <>
          {" "}
          <div className="row">
            <div className="col d-flex justify-content-between">
              <div>
                <h3>Propuestas</h3>
              </div>
              <div>
                <button
                  className="baseBtn"
                  onClick={() => history.push(ROUTES.Propuestas.create)}
                >
                  + Añadir
                </button>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <Form.Group as={Col}>
              <InputGroup className="shadow">
                <InputGroup.Prepend>
                  <InputGroup.Text className="inputGroup ">
                    <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Buscar por título o referencia..."
                  className="form-control"
                  onChange={({ target: { value } }) => searchBar(value)}
                />
              </InputGroup>
            </Form.Group>
          </div>
          <Table striped bordered hover>
            <thead>
              <tr>
                {Object.keys(columnHeaders).map((col) => (
                  <th
                    key={col}
                    onClick={() => sortByColumn(col)}
                    style={{ cursor: "pointer" }}
                  >
                    {columnHeaders[col]}{" "}
                    {sortConfig?.key === col
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : ""}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {displayPropuestas.length > 0 ? (
                displayPropuestas.map(
                  ({
                    id,
                    estado,
                    referencia,
                    acronimo,
                    fechaInicio,
                    staffIp,
                    gestionadoPor,
                  }: any) => (
                    <tr
                      key={id}
                      onClick={() => history.push(`${paths.PROPUESTAS}/${id}`)}
                    >
                      <td>{estado}</td>
                      <td>{referencia}</td>
                      <td>{acronimo}</td>
                      <td>
                        {new Date(fechaInicio).toLocaleDateString("es-AR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "2-digit",
                        })}
                      </td>

                      <td>
                        {staffIp
                          .map(
                            (person: any) =>
                              `${person.nombre} ${person.apellidos}`
                          )
                          .join(", ")}
                      </td>
                      <td>{gestionadoPor}</td>
                    </tr>
                  )
                )
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    No hay propuestas para mostrar
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );
};
